import React from "react";
import {
  AccountBalanceWalletOutlined,
  AssessmentOutlined,
  AssignmentOutlined,
  ChatBubbleOutline,
  DateRangeOutlined,
  FolderSharedOutlined,
  NotificationsNoneOutlined,
  PersonOutline,
  ShowChartOutlined,
  TodayOutlined,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useParent } from "../../../context/ParentContext";
import "./parent-dashboard.css";

const DASHBOARD_ITEMS = [
  {
    title: "Student Profile",
    description: "View personal, academic and guardian details",
    path: "/parent/student-profile",
    icon: PersonOutline,
    tone: "teal",
  },
  {
    title: "Monthly Student Attendance",
    description: "Review attendance and discipline updates",
    path: "/parent/student-attendance",
    icon: TodayOutlined,
    tone: "blue",
  },
  {
    title: "Student Home Work",
    description: "View homework assigned for every subject",
    path: "/parent/student-home-work",
    icon: AssignmentOutlined,
    tone: "indigo",
  },
  {
    title: "Announced Date Sheets",
    description: "View upcoming examination schedules",
    path: "/parent/date-sheets",
    icon: DateRangeOutlined,
    tone: "violet",
  },
  {
    title: "Exam Results",
    description: "See marks, grades and subject performance",
    path: "/parent/exam-results",
    icon: AssessmentOutlined,
    tone: "green",
  },
  {
    title: "Progression Charts",
    description: "Track academic progress over time",
    path: "/parent/progression-charts",
    icon: ShowChartOutlined,
    tone: "orange",
  },
  {
    title: "School Notifications",
    description: "Stay informed with the latest school updates",
    path: "/parent/school-notifications",
    icon: NotificationsNoneOutlined,
    tone: "red",
  },
  {
    title: "School Resources",
    description: "Access learning material shared by school",
    path: "/parent/school-resources",
    icon: FolderSharedOutlined,
    tone: "cyan",
  },
  {
    title: "Teacher Chat",
    description: "Message class and subject teachers",
    path: "/parent/teacher-chat",
    icon: ChatBubbleOutline,
    tone: "blue",
  },
  {
    title: "Fee Status",
    description: "Check unpaid challans and payment history",
    path: "/parent/fee-status",
    icon: AccountBalanceWalletOutlined,
    tone: "amber",
  },
];

export default function ParentDashboard() {
  const {
    selectedChild,
    unreadStatusCount,
    unreadResultCount,
    unreadFeeCount,
    unreadGeneralCount,
  } = useParent();
  const history = useHistory();
  const studentName = selectedChild?.student?.name || "Student";

  return (
    <section className="parent-dashboard-page">
      <header className="parent-dashboard-header">
        <span>Parent overview</span>
        <h1>Dashboard</h1>
        <p>
          {selectedChild
            ? `Quick access to attendance, homework, results, fees and school updates for ${studentName}.`
            : "Select a child to view their school information."}
        </p>
      </header>

      <div className="parent-dashboard-grid">
        {DASHBOARD_ITEMS.map(
          ({ title, description, path, icon: Icon, tone }) => {
            const unreadCount =
              path === "/parent/student-attendance"
                ? unreadStatusCount
                : path === "/parent/exam-results"
                ? unreadResultCount
                : path === "/parent/fee-status"
                ? unreadFeeCount
                : path === "/parent/school-notifications"
                ? unreadGeneralCount
                : 0;
            return (
              <button
                type="button"
                className={`parent-dashboard-card tone-${tone}`}
                onClick={() => history.push(path)}
                key={title}
              >
                <span className="parent-dashboard-icon">
                  <Icon />
                </span>
                <span className="parent-dashboard-content">
                  <strong>{title}</strong>
                  <small>{description}</small>
                  {unreadCount > 0 && (
                    <span className="parent-dashboard-unread-count">
                      {unreadCount} unread
                    </span>
                  )}
                </span>
                <span className="parent-dashboard-arrow" aria-hidden="true">
                  ›
                </span>
              </button>
            );
          },
        )}
      </div>
    </section>
  );
}
